import jwt_decode from "jwt-decode";

const prepareText = (text) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

const preparePath = (path) => {
  let _path = prepareText(path).toLowerCase().split(" ");
  return _path.join("_");
};

const makeTree = (_skirts, parent) => {
  let result = [];
  _skirts.forEach((_skirt, i) => {
    if (_skirts[i].parent === parent) {
      const children = makeTree(_skirts, _skirts[i].id);
      if (children.length) {
        _skirts[i].children = children;
      }
      result.push(_skirts[i]);
    }
  });
  return result;
};

const isAdmin = (token) => {
  const decoded = jwt_decode(token);
  const admin = (decoded?.admin || "").split(" ").join("");
  return Number(admin) === 1;
};

const findAlertDate = (str) => {
  return str.match(/\d{2}-\d{2}-\d{4}/gi);
};

const findAlertTitle = (str) => {
  const start = str.indexOf("<b>");
  const end = str.indexOf("</b>");
  return str.slice(start + 3, end);
};

const pascalCase = (string = "") =>
  string.replace(
    /(\w)(\w*)/g,
    (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase()
  );

const resolveUserTienda = (isAdmin, loggedUser) => {
    if (isAdmin) return null;
    const stores = loggedUser?.store;
    if (Array.isArray(stores) && stores.length > 0) return stores[0]; // codLocal
    return -1; // single, consistent sentinel for 'no store'
 };

export {
  prepareText,
  makeTree,
  isAdmin,
  preparePath,
  findAlertDate,
  findAlertTitle,
  pascalCase,
  resolveUserTienda,
};
